import { render } from "./welcome-back-current.vue?vue&type=template&id=399a83f8"
import script from "./welcome-back-current.vue?vue&type=script&lang=js"
export * from "./welcome-back-current.vue?vue&type=script&lang=js"

import "./welcome-back-current.vue?vue&type=style&index=0&id=399a83f8&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__